import { ReactNode } from 'react';
import { plgTheme } from './theme';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <GetBrandTheme brandTheme={plgTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
